/**
 * @license Copyright 2020 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.dashboard {
  display: flex;
  flex-direction: column;
}

.dashboard__url-branch-selector {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  margin-bottom: var(--base-spacing);
}

.dashboard__url-branch-selector > * {
  margin-right: var(--base-spacing);
}

.dashboard__url-branch-selector .dropdown--url select {
  max-width: 300px;
}

.dashboard__url-branch-selector .dropdown--branch select {
  max-width: 120px;
}

.dashboard--scrolled .dashboard__url-branch-selector {
  position: fixed;
  z-index: 11;
  top: 0;
  left: var(--page-header-height);
  right: var(--page-header-height);
  height: var(--page-header-height);
}

/** fill in some of the space that dissappears when it flips to position: fixed */
.dashboard--scrolled #dashboard__scroll-height-detector {
  height: calc(var(--base-spacing) + var(--base-font-size));
}
